import { render, staticRenderFns } from "./FooterGithub.vue?vue&type=template&id=34d995c4&"
import script from "./FooterGithub.vue?vue&type=script&lang=js&"
export * from "./FooterGithub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports